import React, { Component } from 'react';
import { Styles } from '../styles/courseSearch.js';

class CourseSearch extends Component {

    render() {
        return (
            <Styles>
                {/* Course Search */}
                <div className="course-search">
                    <h5>Proje Ara</h5>
                    <form action="#">
                        <input type="text" name="search" placeholder="Bilgileri Giriniz" />
                        <button type="submit"><i className="las la-search"></i></button>
                    </form>
                </div>
            </Styles>
        )
    }
}

export default CourseSearch
